import ReactDOM from "react-dom";
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { LinkProps } from '@mui/material/Link';
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import store from "./store/store";
import { CssBaseline } from "@mui/material";
import { UWStyle } from "./constants/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ModelMain from "./features/models/views/ModelMain";
import CapsView from "./components/CapsView";
import PathsView from "./features/paths/views/PathsMain";
import React from "react";
import PathsTypesLanding from "./features/paths/views/PathsTypesLanding";
const muiCache = createCache({
  key: "mui",
  prepend: true,
});
// Create the store

const LinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props;
  // Map href (MUI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
});

const getMuiTheme = () =>
  createTheme({
    palette: {
      primary: {
        main: UWStyle.primaryBG,
      },
      secondary: {
        main: UWStyle.secondaryBG,
      },
    },

    components: {
      MuiLink: {
        defaultProps: {
          component: LinkBehavior,
        } as LinkProps,
      },
      MuiButtonBase: {
        defaultProps: {
          LinkComponent: LinkBehavior,
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            "&:hover": {
              color: UWStyle.primaryBG,
            },
          },
        },
      },
      MuiAutocomplete: {
        defaultProps: {
          componentsProps: {
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            },
          },
        },
      },
      MuiPaper: {
        defaultProps: { elevation: 0 },
      },
      //@ts-ignore
      MUIDataTableFilterList: {
        styleOverrides: {
          chip: {
            margin: "0.5em",
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {

          root: {
            paddingTop: 12,
            paddingBottom: 12,
            paddingLeft: 8,
            paddingRight: 8,
            lineHeight: 1,
            "& .MuiSvgIcon-root": {
              marginTop: 0,
              marginLeft: 0,
              fontSize: 16,
            },
          },
          fixedHeader: {
            "& div": {
              justifyContent: "space-between",
              alignItems: "center",
            },

            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: UWStyle.primaryBG,
            color: UWStyle.contrastText,
            fontWeight: 600,
          },
          sortLabelRoot: {

            color: UWStyle.contrastText,

          },
          sortActive: {

            color: UWStyle.contrastText
          },

        },
      },
      MUIDataTableBodyCell: {
        styleOverrides: {
          root: {
            "& .MuiIconButton-root": {
              padding: 0,
            },
            padding: 4,
          },
        },
      },
    },
  });

  const router = createBrowserRouter([
    {
      path: "/",
      element: <App />,
    children:[
      {
        path:"paths/:name",
        element: <PathsTypesLanding /> 
      },
      {
        path:"paths",
        element: <PathsTypesLanding /> 
      },
      {
        path:"models",
        element: <ModelMain />,

      },
      {
        path:"caps",
        element:<CapsView />,
      },
    ]
  },
],
)


ReactDOM.render(
  <CacheProvider value={muiCache}>
    <ThemeProvider theme={getMuiTheme()}>
      <Provider store={store}>
        <CssBaseline />
        <RouterProvider router = {router} />
      </Provider>
    </ThemeProvider>
  </CacheProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
